import ErrorHandler from "../error-handlers/axios/defaultErrorHandler";

/**
 * Fetches team performance data
 *
 * @param {Object} axiosInstance - Axios instance with authentication
 * @param {Object} options - Request options
 * @param {Object} options.params - Query parameters
 * @param {string} options.params.period - Time period ('daily', 'weekly', 'monthly')
 * @param {string} options.params.startDate - Start date in ISO format
 * @param {string} options.params.endDate - End date in ISO format
 * @param {number} options.params.limit - Maximum number of teams to return
 * @param {number} options.params.skip - Number of teams to skip (for pagination)
 * @returns {Promise<Object>} - Team performance data with totalCount and data array
 */
export const getTeamPerformance = async (axiosInstance, options = {}) => {
  try {
    const res = await axiosInstance.get('/agent-performance/team-performance', options);
    return res?.data;
  } catch (error) {
    ErrorHandler.handle(error);
    return { totalCount: 0, data: [], error: true };
  }
};
